import React from 'react'
import yn from 'yn'
import formatPrice from '../../../../utilities/currency/formatPrice'

const BkFlowRoomCardRateStageCta = props => {
	const {
		ctaEvent,
		currencyCode,
		currencySymbol,
		displayedPriceFrequency,
		hotelLabels,
		hotelPhone,
		lowestRate,
		totalRates,
	} = props

	return (
		totalRates ? (
				<div className="bk-flow-room__card-stage-cta">
					{lowestRate &&
						<div className="bk-flow-room__card-stage-cta-content">
							<p className="u-remove-margin label u-font-small">{ totalRates } {hotelLabels && hotelLabels.offersFrom ? ' ' + hotelLabels.offersFrom  : 'Offers From'}</p>
							<p className="u-remove-margin rate">
								<span className="price">{ currencySymbol && currencySymbol }{ formatPrice(lowestRate, 2, true) }</span>
								{ currencyCode &&
									displayedPriceFrequency === 'per stay' ? (
										<span className="currency u-font-small">&nbsp;{currencyCode} / { hotelLabels && hotelLabels.total ? hotelLabels.total : 'Total' }</span>
									) : currencyCode ? (
										<span className="currency u-font-small">
											&nbsp;{currencyCode}&nbsp;
											{ yn(process.env.REACT_APP_COMPONENT_PRICE_AVG_LABELS) && hotelLabels && hotelLabels.avg ? hotelLabels.avg : 'Avg' }&nbsp;/&nbsp;
											{ hotelLabels && hotelLabels.night ? hotelLabels.night : 'Night' }
										</span>
									) : (
										null
									)
								}
							</p>
						</div>
					}

					<button
						className="btn btn-primary"
						onClick={() => ctaEvent()}
					>
						<span className="desktop">{ hotelLabels && hotelLabels.viewAvailableRates ? hotelLabels.viewAvailableRates : 'View Available Rates +'}</span>
						<span className="mobile">{ hotelLabels && hotelLabels.viewRates ? hotelLabels.viewRates : 'View Rates +'}</span>
					</button>
				</div>
		) : (
			<div className="bk-flow-room__card-stage-cta">
				<div className="bk-flow-room__card-stage-cta-content unavailable">
					<h6>{ hotelLabels.propertyUnavailableTitle ? hotelLabels.propertyUnavailableTitle + '?' : 'Change in Plans?' }</h6>
					<p>{ hotelLabels.propertyUnavailableMessage ? hotelLabels.propertyUnavailableMessage + '?' : 'Dates can’t budge? Choose a different room. If you love this room, select different dates or call' }:</p>
					{ hotelPhone && <a href={ 'tel:' + hotelPhone }>{ hotelPhone }</a> }
				</div>
			</div>
		)
	)
}

export default BkFlowRoomCardRateStageCta



// WEBPACK FOOTER //
// ./src/components/room/elements/multi-stage/BkFlowRoomCardRateStageCta.js